import axios from 'axios'

/**
 * @desc Fetch all processed transactions
 */
export const fetchProcessedTransactionGroups = (paymentType) =>
  axios
    .get('/authenticated/payment-transactions/processed', {
      params: {
        paymentType
      }
    })
    .then((res) => res.data)

export const fetchProcessedTransactionsExcel = (periodEndDate, paymentType) =>
  axios
    .get(`/authenticated/payment-transactions/processed/excel`, {
      responseType: 'arraybuffer',
      params: {
        periodEndDate,
        paymentType
      }
    })
    .then((res) => res.data)

/**
 * @desc Fetch all expected transactions
 */
export const fetchExpectedTransactionGroups = (paymentType) =>
  axios
    .get('/authenticated/payment-transactions/expected', {
      params: {
        paymentType
      }
    })
    .then((res) => res.data)

/**
 * @desc Fetch all expected transactions
 */
export const fetchPendingTransactionGroups = (paymentType) =>
  axios
    .get('/authenticated/payment-transactions/pending', {
      params: {
        paymentType
      }
    })
    .then((res) => res.data)
